// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-ZXE","question":"styles_question__3fsVa","inputVisibleButton":"styles_inputVisibleButton__3mlWJ","note":"styles_note__2v0hp"};